import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const getReplenishmentPO = createAsyncThunk('getReplenishmentPO', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-orders`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const createReplenishmentPO = createAsyncThunk('createReplenishmentPO', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-order/create`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getReplenishmentEligiblePO = createAsyncThunk('getReplenishmentEligiblePO', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-order/${data?.po_id}/styles`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getReplenishmentOverallPO = createAsyncThunk('getReplenishmentOverallPO', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-order/${data?.po_id}/styles/overall`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getReplenishmentPOSummary = createAsyncThunk('getReplenishmentPOSummary', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-order/${data?.po_id}/summary`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const addReplenishmentPoStyles = createAsyncThunk('addReplenishmentPoStyles', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/replenishment/purchase-order/${data?.po_id}/styles/add`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});